import { Button } from '@/components/ui/button'

interface PaginacaoProps {
  currentPage: number
  totalPages: number
  setCurrentPage: (page: number) => void
}

export const Paginacao = ({
  currentPage,
  totalPages,
  setCurrentPage,
}: PaginacaoProps) => {
  if (totalPages <= 1) return null

  return (
    <div className='mb-10 mt-6 flex justify-center gap-2'>
      <Button
        variant='outline'
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        className='border-esforce-green-200 bg-esforce-black-300 text-esforce-white-100'
      >
        Anterior
      </Button>
      <span className='flex items-center px-4 text-esforce-white-100'>
        Página {currentPage} de {totalPages}
      </span>
      <Button
        variant='outline'
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className='border-esforce-green-200 bg-esforce-black-300 text-esforce-white-100'
      >
        Próxima
      </Button>
    </div>
  )
}
